import { comics, trendingComicSlugs } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

const trendingComics = trendingComicSlugs
  .map((slug) => comics.find((c) => c.slug === slug))
  .filter(Boolean) as NonNullable<ReturnType<typeof comics.find>>[];

export default function TrendingSection() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            趋势排行
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            全网最热门漫画，大家都在看
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-5">
          {trendingComics.map((comic, index) => (
            <div key={comic.id} className="relative">
              <div className="absolute -top-2 -left-2 z-10 w-8 h-8 md:w-9 md:h-9 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 flex items-center justify-center font-bold text-sm shadow-lg">
                {index + 1}
              </div>
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}